import { sessionPrefix } from "./helpers";

export const projectUploadsPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/project/uploads`;
export const newProjectUploadPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/project/uploads/new`;
export const projectUploadPath = (session: LightSessionInterface, upload: UploadRef) =>
  `${sessionPrefix(session)}/project/uploads/${upload.id}`;
